<template>
  <component :is="logoComponent" v-bind="$attrs" :class="['logo', logoSize]" />
</template>

<script lang="ts">
import LogoOnestop from '@/assets/theme/images/logo-onestop.svg?component';
import LogoIndo from '@/assets/theme/images/logo-indo.svg?component';
import LogoRodenstock from '@/assets/theme/images/logo-rodenstock.svg?component';
import LogoIndoImage from "@/assets/theme/images/logo-indo-image.svg?component";
import LogoRodenstockImage from '@/assets/theme/images/logo-rodenstock-image.svg?component';
import LogoOptovision from '@/assets/theme/images/logo-optovision.svg?component';
import LogoOptovisionImage from '@/assets/theme/images/logo-optovision-image.svg?component';
import LogoOneVisionShop from '@/assets/one-vision-shop-ico.svg?component';

export const logos = {
  onestop: LogoOnestop,
  "one-vision-shop": LogoOneVisionShop,
  indo: LogoIndo,
  rodenstock: LogoRodenstock,
  "indo-image": LogoIndoImage,
  "rodenstock-image": LogoRodenstockImage,
  optovision: LogoOptovision,
  "optovision-image": LogoOptovisionImage,
} as const;

export type LogoKey = keyof typeof logos;
export type LogoSize = 'sm' | 'md' | 'lg';
</script>

<script setup lang="ts">
import { computed } from 'vue';

defineOptions({ name: 'Logo' });

const props = withDefaults(
  defineProps<{ brand: string; size?: LogoSize; colored?: boolean }>(),
  { size: 'md', colored: true },
);

const logoComponent = computed(() => logos[props.brand as LogoKey] ?? null);
const logoSize = computed(() => `logo-${props.size}`);
</script>

<style scoped>
.logo {
  display: inline-block;
  width: auto;
}

.logo-sm {
  height: 1.7rem;
}

.logo-md {
  height: 2rem;
}

.logo-lg {
  height: 3rem;
}
</style>
